import {
  FileExplorerCountSecurityAlertsInResourceApi,
  FileExplorerListPathApi,
  ListPathSnapshotsApi,
  type Configuration,
} from '@repo/api-gw-sdk';

import { dayjs } from '@/utils/dayjs';

import type { HttpClient } from './httpClient';

const baseUrl = '/explorer';

export const explorer = (
  httpClient: HttpClient,
  config: Configuration,
  currentProjectId: string
) => {
  const snapshotsClient = new ListPathSnapshotsApi(config);
  const listPathClient = new FileExplorerListPathApi(config);
  const fileExplorerCountSecurityAlertsInResourceApi =
    new FileExplorerCountSecurityAlertsInResourceApi(config);

  return {
    useListPath: (
      resourceId: string,
      prefix: string,
      pageSize: number,
      pageToken?: string,
      securityAlertedOnly?: boolean,
      snapshotId?: string
    ) => {
      return httpClient.execute(
        listPathClient.fileExplorerListPath.bind(listPathClient),
        baseUrl,
        'listPath',
        currentProjectId,
        resourceId,
        prefix,
        pageSize,
        pageToken,
        securityAlertedOnly,
        snapshotId
      );
    },
    useListPathSnapshots: (
      resourceId: string,
      path: string,
      start: Date,
      end: Date,
      pageIndex: number,
      pageSize: number
    ) => {
      const startWithoutTime = dayjs.utc(start).startOf('day').toDate();
      const endWithoutTime = dayjs.utc(end).endOf('day').toDate();
      return httpClient.execute(
        snapshotsClient.listPathSnapshots.bind(snapshotsClient),
        path ? baseUrl : null,
        'listPathSnapshots',
        currentProjectId,
        resourceId,
        startWithoutTime,
        endWithoutTime,
        pageIndex,
        pageSize,
        { path }
      );
    },
    useCountSecurityAlerts: (resourceId: string, snapshotId?: string) =>
      httpClient.execute(
        fileExplorerCountSecurityAlertsInResourceApi.fileExplorerCountSecurityAlertsInResource.bind(
          fileExplorerCountSecurityAlertsInResourceApi
        ),
        baseUrl,
        'countInfectedInResource',
        currentProjectId,
        resourceId,
        snapshotId
      ),
  };
};
